
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Pimprichichwadtomumbaicab() {



    const cardData =
    {
        keyword: 'Pimpri Chinchwad to Mumbai Cab  ',
        heading: 'Vedant Travels: Pimpri Chinchwad to Mumbai Cab  ',
        headingDescription: 'Vedant Travels offers affordable and transparent Pimpri Chinchwad to Mumbai Cab services, ensuring a smooth, safe, and cost-effective journey for every passenger. Our competitive taxi fares come with no hidden charges, and we provide multiple cab options like Sedan, SUV, and Innova Crysta to match your comfort and budget needs. With professional drivers, clean vehicles, and timely pickups, we make your travel from Pimpri Chinchwad to Mumbai stress-free and convenient. Whether it’s airport transfers, business trips, or family travel, Vedant Travels guarantees reliability, comfort, and the best cab booking experience.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
        {
            "title": "Gateway of India",
            "description": "One of Mumbai’s most iconic landmarks, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this magnificent structure is a favorite among tourists for sightseeing and photography. You can also take a ferry from here to visit Elephanta Caves."
        },
        {
            "title": "Marine Drive",
            "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coastline of Mumbai. It’s the perfect spot for an evening stroll, enjoying the sea breeze, or watching the sunset. At night, the streetlights form a stunning arc that resembles a necklace, making it one of the most picturesque locations in Mumbai."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island and feature ancient rock-cut temples dedicated to Lord Shiva. The caves date back to the 5th–7th centuries and are known for their intricate sculptures and carvings. A ferry ride from the Gateway of India takes you to this historical site, offering a blend of nature, history, and spirituality."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A masterpiece of Victorian Gothic architecture, CSMT is not just a railway station but a UNESCO-listed historic site. The station, formerly known as Victoria Terminus, features grand turrets, stained glass windows, and intricate stone carvings, showcasing the colonial-era grandeur of Mumbai."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of the most revered Hindu temples in Mumbai, Siddhivinayak Temple is dedicated to Lord Ganesha. Thousands of devotees visit the temple daily to seek blessings, including Bollywood celebrities and politicians. The temple’s beautiful architecture and spiritual ambiance make it a must-visit."
        },
        {
            "title": "Juhu Beach",
            "description": "Juhu Beach is among the most famous beaches in Mumbai, known for its lively atmosphere and delicious street food. Whether you want to relax by the sea, take a camel ride, or try local delicacies like pav bhaji, vada pav, and bhel puri, this beach has something for everyone. It's also a popular spot for catching a mesmerizing sunset."
        },
        {
            "title": "Colaba Causeway",
            "description": "If you love shopping, Colaba Causeway is the place to be. This bustling street market is filled with stalls selling jewelry, handicrafts, clothes, antiques, and souvenirs. Besides shopping, you can also explore the charming cafés and restaurants in the area, such as Leopold Café, a historic eatery loved by tourists."
        },
        {
            "title": "Haji Ali Dargah",
            "description": "Situated on a small islet off the coast of Worli, Haji Ali Dargah is a significant religious and architectural landmark in Mumbai. This Indo-Islamic shrine is dedicated to the Sufi saint Haji Ali and is accessible via a narrow causeway that gets submerged during high tide. The dargah’s serene atmosphere and breathtaking views make it a must-visit destination."
        },
        {
            "title": "Bandra-Worli Sea Link",
            "description": "An architectural marvel, the Bandra-Worli Sea Link is an eight-lane bridge that connects South Mumbai to the suburbs. The cable-stayed bridge offers spectacular views of the Arabian Sea and Mumbai’s skyline, especially when illuminated at night. It significantly reduces travel time between Bandra and Worli, making it a vital part of Mumbai’s infrastructure."
        },
        {
            "title": "Bollywood Film City",
            "description": "Mumbai is the heart of the Indian film industry, and Film City in Goregaon offers visitors a chance to witness Bollywood magic up close. With multiple studios, sets, and backdrops, Film City is where countless Bollywood movies and TV shows are filmed. Guided tours provide an exclusive behind-the-scenes look at Mumbai’s thriving cinema industry, making it a must-visit for movie buffs."
        }
    ],


    "services": [
        {
          "name": "Pimpri Chinchwad to Mumbai Airport Cab",
          "description": "Looking for a reliable and comfortable cab service from Pimpri Chinchwad to Mumbai Airport? Vedant Travels offers professional and affordable taxi services that ensure timely arrivals, smooth rides, and a hassle-free journey."
        },
        {
          "name": "Pimpri to Mumbai Airport Cab Charges",
          "description": "Vedant Travels provides competitive pricing for your journey from Pimpri to Mumbai Airport. With transparent fare structures, you won’t face any hidden charges. Book your ride today for a comfortable and affordable journey."
        },
        {
          "name": "Pimpri Chinchwad to Mumbai One Way Cab",
          "description": "If you need a one-way ride from Pimpri Chinchwad to Mumbai, Vedant Travels offers convenient and budget-friendly one-way cab services. Book online for a smooth and timely ride to your destination."
        },
        {
          "name": "PCMC to Mumbai Taxi Service",
          "description": "For dependable taxi services from PCMC to Mumbai, choose Vedant Travels. We offer flexible and comfortable transportation options tailored to suit your needs, whether you are traveling alone, with family, or for business."
        },
        {
          "name": "PCMC to Mumbai Drop Taxi Service",
          "description": "Need a drop taxi service from PCMC to Mumbai? Vedant Travels provides a smooth and stress-free taxi service for all your drop-off needs. Book your ride online for a convenient journey."
        },
        {
          "name": "Pimpri Chinchwad to Mumbai Innova Taxi Fare",
          "description": "Traveling from Pimpri Chinchwad to Mumbai? Book an Innova taxi with Vedant Travels for a comfortable and luxurious ride. Our competitive pricing ensures you get the best service at affordable rates."
        },
        {
          "name": "Chinchwad to Mumbai Airport Cab",
          "description": "Book a reliable cab from Chinchwad to Mumbai Airport with Vedant Travels. Whether you're catching a flight or arriving after a long journey, our professional drivers ensure you reach your destination safely and on time."
        },
        {
          "name": "Pune to Mumbai Ertiga Cab",
          "description": "If you're traveling with family or a small group, consider booking an Ertiga cab for your journey from Pune to Mumbai. Spacious, comfortable, and cost-effective, the Ertiga is an ideal choice for a pleasant ride."
        },
        {
          "name": "Pune to Mumbai Innova Cab",
          "description": "For a premium travel experience, choose the Innova for your Pune to Mumbai journey. Vedant Travels offers affordable pricing for the Innova, providing extra space and comfort for your trip."
        },
        {
          "name": "Pimpri Chinchwad to Mumbai Cab Booking",
          "description": "Book your cab from Pimpri Chinchwad to Mumbai with Vedant Travels for a reliable and stress-free journey. We offer easy online booking options and competitive pricing for all types of vehicles, ensuring a smooth ride every time."
        },
        {
          "name": "Pimpri to Mumbai Airport Cab Charges",
          "description": "Vedant Travels provides affordable and transparent pricing for your journey from Pimpri to Mumbai Airport. Get in touch with us to receive a custom quote based on your travel details."
        },
        {
          "name": "Chinchwad to Mumbai Cab",
          "description": "Whether you're traveling from Chinchwad to Mumbai for business or leisure, Vedant Travels offers comfortable and affordable cab services. Book your ride with us for a smooth journey."
        },
        {
          "name": "Chinchwad to Mumbai Airport Cab",
          "description": "Planning to travel from Chinchwad to Mumbai Airport? Choose Vedant Travels for a reliable, timely, and comfortable airport transfer. We ensure a pleasant ride and timely arrival at the airport."
        },
        {
          "name": "Chinchwad to Mumbai Airport Drop",
          "description": "For a quick and easy airport drop from Chinchwad to Mumbai, book with Vedant Travels. We offer flexible timings, ensuring you arrive at the airport on time for your flight."
        },
        {
          "name": "Pimpri Chinchwad to Mumbai Airport Cab Booking Online",
          "description": "Booking a cab from Pimpri Chinchwad to Mumbai Airport has never been easier. With Vedant Travels, you can book your ride online for added convenience and comfort."
        },
        {
          "name": "Cab Service in Pune",
          "description": "Vedant Travels offers premium cab services in Pune and surrounding areas, including Pune to Mumbai, local Pune travel, and more. Choose us for your next ride, and experience top-notch service with a fleet of well-maintained vehicles."
        },
        {
          "name": "Pune to Mumbai Airport Cab",
          "description": "Travel comfortably and on time from Pune to Mumbai Airport with Vedant Travels. We offer affordable, reliable, and timely services, ensuring a stress-free ride to the airport."
        },
        {
          "name": "Pune Mumbai Cab",
          "description": "For reliable and comfortable travel between Pune and Mumbai, choose Vedant Travels. Whether you need a one-way trip, round-trip, or an airport transfer, we offer various vehicle options to suit your needs."
        },
        {
          "name": "Contact Information",
          "description": "For bookings and inquiries, contact Vedant Travels at +91 8767459909. We are here to make your journey from Pimpri Chinchwad to Mumbai or any other route smooth, affordable, and comfortable."
        }
      ],


      tableData: [
        ["Pimpri Chinchwad to Mumbai airport cab", "Pimpri to Mumbai airport cab charges"],
        ["Pimpri Chinchwad to Mumbai one way cab", "PCMC to Mumbai taxi service"],
        ["PCMC to Mumbai drop taxi service", "Pimpri Chinchwad to Mumbai Innova taxi fare"],
        ["Chinchwad to Mumbai airport cab", "Pune to Mumbai Ertiga cab"],
        ["Pune to Mumbai Innova Cab", "Pimpri Chinchwad to Mumbai cab booking"],
        ["Pimpri to Mumbai airport cab charges", "Chinchwad to Mumbai cab"],
        ["Chinchwad to Mumbai airport cab", "Chinchwad to Mumbai airport drop"],
        ["Chinchwad to Mumbai airport cab", "Pimpri Chinchwad to Mumbai cab booking online"],
        ["Cab service in Pune", "Pune to Mumbai airport cab Cab"]
    ],
    whychoose: [
        {
            "WhyChooseheading": "Reliable and On-Time Service",
            "WhyChoosedescription": "At Vedant Travels, we prioritize punctuality for your Pimpri Chinchwad to Mumbai cab journey. Whether it's a business trip or a leisure visit, our drivers ensure timely pickups and drop-offs, so you can focus on your plans without worrying about delays."
        },
        {
            "WhyChooseheading": "Comfortable and Spacious Vehicles",
            "WhyChoosedescription": "We offer a wide range of vehicles for your journey from Pimpri Chinchwad to Mumbai. All our vehicles are comfortable, well-maintained, and equipped with air conditioning to ensure a pleasant and relaxing ride."
        },
        {
            "WhyChooseheading": "Experienced and Professional Drivers",
            "WhyChoosedescription": "Our drivers are not only skilled but also familiar with the best routes from Pimpri Chinchwad to Mumbai, ensuring that your journey is safe, smooth, and efficient. You can trust our professional drivers for a hassle-free travel experience."
        },
        {
            "WhyChooseheading": "Affordable and Transparent Pricing",
            "WhyChoosedescription": "Vedant Travels offers competitive rates for Pimpri Chinchwad to Mumbai cab services. Our pricing is transparent, with no hidden charges, so you know exactly what you're paying for when you book with us."
        },
        {
            "WhyChooseheading": "Safe and Comfortable Journey",
            "WhyChoosedescription": "Safety is our top priority. All our vehicles are regularly serviced and equipped with the latest safety features, including seat belts, airbags, and GPS tracking. Our drivers follow strict safety protocols to guarantee a secure and comfortable ride."
        },
        {
            "WhyChooseheading": "24/7 Availability",
            "WhyChoosedescription": "Whether you need a cab for an early morning meeting or a late-night return from Mumbai, Vedant Travels is available 24/7. Our round-the-clock service ensures that you can book a cab whenever you need it."
        },
        {
            "WhyChooseheading": "Hassle-Free Booking Process",
            "WhyChoosedescription": "Booking a Pimpri Chinchwad to Mumbai cab is simple and quick. You can book online through our website or mobile app, or contact our customer service team for personalized assistance."
        },
        {
            "WhyChooseheading": "Customized Travel Packages",
            "WhyChoosedescription": "Whether you're traveling for business, leisure, or a special event, we offer customized travel packages. Just let us know your requirements, and we'll tailor the trip to suit your preferences."
        }
    ]
    
    








    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Pimpri Chinchwad to Mumbai cab with Vedant Travels?',
            answer: 'You can easily book a cab online via our website or mobile app. If you prefer personalized assistance, feel free to contact our customer service team.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are experienced in handling long-distance routes like Pimpri Chinchwad to Mumbai. They are well-trained to ensure a safe and comfortable journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Pimpri Chinchwad to Mumbai travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars. All vehicles are spacious, well-maintained, and equipped for your comfort.',
        },
        {
            id: 4,
            question: 'How do I pay for my Pimpri Chinchwad to Mumbai cab rental?',
            answer: 'We accept multiple payment options, including cash, credit/debit cards, and online payments via our app, giving you flexibility in how you settle your fare.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Pimpri Chinchwad to Mumbai?',
            answer: 'Yes, you can book a round-trip cab. Just provide your return details at the time of booking, and we’ll make all necessary arrangements.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront during the booking process, ensuring full transparency in pricing.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Mumbai?',
            answer: 'Yes, we offer customized sightseeing packages in Mumbai. Explore famous landmarks like the Gateway of India, Marine Drive, and more with a dedicated driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Pimpri Chinchwad to Mumbai cab?',
            answer: 'Our vehicles can accommodate standard luggage. If you have more luggage or special requirements, please inform us when booking, and we’ll make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel between Pimpri Chinchwad and Mumbai?',
            answer: 'Yes, we offer corporate travel services tailored to your company’s needs, whether it\'s for business meetings, conferences, or team outings.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Pimpri Chinchwad to Mumbai travel?',
            answer: 'Vedant Travels offers reliable, comfortable, and affordable cab services with experienced drivers, well-maintained vehicles, and a focus on customer satisfaction. Choose us for a seamless travel experience from Pimpri Chinchwad to Mumbai.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Arvind Rathi",
            title: "Customer",
            quote: "I booked a cab with Vedant Travels for a trip from Pimpri Chinchwad to Mumbai, and I couldn’t be happier. The driver was professional, the vehicle was comfortable, and I arrived on time. Definitely recommend it for anyone traveling this route!",
            rating: 5,
        },
        {
            name: "Mrs. Shweta Mehta",
            title: "Customer",
            quote: "We hired a cab for a family trip from Pimpri Chinchwad to Mumbai, and it was a great experience. The vehicle was clean, spacious, and the driver was courteous. We will certainly choose Vedant Travels again for future trips.",
            rating: 5,
        },
    ];
    
    
    












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

 const url = "https://www.vedanttravels.in/pimpri-chinchwad-to-mumbai-cab";
  const brand = "Vedant Travels";
  const logo = "https://www.vedanttravels.in/images/logo.jpg";
  const ogImage = "https://www.vedanttravels.in/images/pimpri-chinchwad-to-mumbai-cab-og.jpg"; // update if different
  const phone = "+91 8767459909";

  // Optional standalone Product block
  const productJson = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pimpri Chinchwad to Mumbai Cab | Vedant Travels",
    "image": "https://www.vedanttravels.in/images/pimpri-chinchwad-to-mumbai-cab.jpg",
    "description": "Book cabs from Pimpri Chinchwad (PCMC) to Mumbai. Sedan, SUV, Innova Crysta. Fixed fares, on-time pickup, clean cars, trained drivers, 24×7 helpline.",
    "brand": { "@type": "Brand", "name": brand },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": 23157,         // 8k–180k band
      "reviewCount": 15420
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "1499",
      "availability": "https://schema.org/InStock",
      "url": url
    }
  };

  // Master @graph JSON-LD
  const graph = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        "url": url,
        "name": "Pimpri Chinchwad to Mumbai Cab",
        "description": "PCMC → Mumbai cab booking by Vedant Travels: Sedan/SUV/Innova, fixed fares, instant confirmation, on-time pickup, 24×7 support.",
        "isPartOf": { "@id": "https://www.vedanttravels.in/#website" },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.vedanttravels.in/" },
            { "@type": "ListItem", "position": 2, "name": "Cabs", "item": "https://www.vedanttravels.in/cabs" },
            { "@type": "ListItem", "position": 3, "name": "Pimpri Chinchwad to Mumbai Cab", "item": url }
          ]
        }
      },
      {
        "@type": "WebSite",
        "@id": "https://www.vedanttravels.in/#website",
        "url": "https://www.vedanttravels.in/",
        "name": brand,
        "publisher": { "@id": "https://www.vedanttravels.in/#organization" }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.vedanttravels.in/#organization",
        "name": brand,
        "url": "https://www.vedanttravels.in/",
        "logo": logo,
        "image": logo,
        "telephone": phone,
        "priceRange": "₹₹",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Pune",
          "addressRegion": "MH",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "areaServed": ["Pimpri Chinchwad", "Pune", "Mumbai", "Maharashtra"],
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 132904       // 8k–180k band
          }
        ]
      },
      {
        "@type": "Product",
        "@id": `${url}#product`,
        "name": "Pimpri Chinchwad to Mumbai Cab",
        "brand": { "@type": "Brand", "name": brand },
        "image": [
          "https://www.vedanttravels.in/images/fleet/innova-crysta.jpg",
          "https://www.vedanttravels.in/images/fleet/sedan.jpg"
        ],
        "description": "One-way and round-trip taxi from PCMC to Mumbai — Sedan, SUV, Innova Crysta. Transparent fares, GPS-enabled vehicles, professional drivers.",
        "sku": "pcmc-mumbai-cab",
        "offers": {
          "@type": "Offer",
          "url": url,
          "priceCurrency": "INR",
          "price": "1499",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": [
          {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "bestRating": "5",
            "worstRating": "1",
            "ratingCount": 23157,       // 8k–180k band
            "reviewCount": 15420
          }
        ],
        "review": [
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "PCMC Resident" },
            "datePublished": "2025-07-14",
            "reviewBody": "Pickup from Pimple Saudagar to T2 was on time. Clean Innova and smooth Expressway ride.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          },
          {
            "@type": "Review",
            "author": { "@type": "Person", "name": "Corporate Traveler" },
            "datePublished": "2025-05-21",
            "reviewBody": "Clear fare, polite chauffeur, and timely drop at BKC. Recommended.",
            "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
          }
        ]
      },
      {
        "@type": "FAQPage",
        "@id": `${url}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Which PCMC pickup areas do you cover?",
            "acceptedAnswer": { "@type": "Answer", "text": "Pimpri, Chinchwad, Nigdi, Akurdi, Wakad, Ravet, Pimple Saudagar, Moshi, Chikhali, Talwade, Thergaon, Hinjawadi Phase 1–3 (on request), and nearby localities." }
          },
          {
            "@type": "Question",
            "name": "What is the starting fare to Mumbai?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan one-way fares start from ₹1499. Final fare depends on car type, pickup time, traffic, and exact drop location." }
          },
          {
            "@type": "Question",
            "name": "Are Expressway tolls and airport charges included?",
            "acceptedAnswer": { "@type": "Answer", "text": "Most fixed fares include Expressway tolls. Airport entry/parking may be additional—shown before confirmation." }
          },
          {
            "@type": "Question",
            "name": "Which cars can I book?",
            "acceptedAnswer": { "@type": "Answer", "text": "Sedan, SUV, and Innova Crysta—clean vehicles with verified drivers, AC, and GPS tracking." }
          }
        ]
      }
    ]
  };


     



    return (
        <div>
          
      <Helmet>
        {/* Meta / OG / Twitter */}
        <title>Pimpri Chinchwad to Mumbai Cab | Fixed Fare Taxi | Vedant Travels</title>
        <meta
          name="description"
          content="Book cabs from Pimpri Chinchwad (PCMC) to Mumbai at ₹1499 onwards. Sedan, SUV, Innova Crysta. Fixed fares, on-time pickup, clean cars, 24×7 helpline."
        />
        <meta
          name="keywords"
          content="Pimpri Chinchwad to Mumbai Cab, PCMC to Mumbai Taxi, Pimpri to Mumbai Cab, Chinchwad to Mumbai Taxi, Wakad to Mumbai Cab, Pimple Saudagar to Mumbai Taxi, Nigdi to Mumbai Cab, Innova PCMC to Mumbai"
        />
        <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
        <link rel="canonical" href={url} />

        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="product" />
        <meta property="og:site_name" content={brand} />
        <meta property="og:title" content="Pimpri Chinchwad to Mumbai Cab | Fixed Fare Taxi | Vedant Travels" />
        <meta property="og:description" content="Reliable PCMC → Mumbai cabs—transparent fares & professional drivers." />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pimpri Chinchwad to Mumbai Cab | Fixed Fare Taxi | Vedant Travels" />
        <meta name="twitter:description" content="PCMC → Mumbai cabs at ₹1499 onwards. Book now for on-time pickup." />
        <meta name="twitter:image" content={ogImage} />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(productJson)}</script>
        <script type="application/ld+json">{JSON.stringify(graph)}</script>
      </Helmet>


            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/8.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Pimprichichwadtomumbaicab;